interface IChatContactProps {
  id: number;
  name: string;
  pubsubToken: string;
}

export class MChatContact {
  props: IChatContactProps;

  constructor(props: IChatContactProps) {
    this.props = props;
  }
}
